module.exports = __webpack_public_path__ + "static/jovalogo-acbf31fc032971a920eed4ca87272b78.png";